import config from 'config';
import { useState } from 'react';
import { useAppDispatch } from 'reducer';
import { errorAlert, successAlert } from 'reducer/slices/alertSlice';
import { hideLoading, showLoading } from 'reducer/slices/loadingSlice';
import { hidePopup } from 'reducer/slices/popupSlice';
import gather from 'tools/gather';

const Add = ({ data = undefined, reload }: any) => {
  const dispatch = useAppDispatch();
  const [user, setUser] = useState(data?.user?._id);
  const [text, setText] = useState(data?.text);

  const submit = async () => {
    dispatch(showLoading());

    const result = await gather(`${config.apiUrl}/v1/admin/alarm${data._id ? '/' + data._id : ''}`, true)[data._id ? 'put' : 'post']({
      user: user,
      text: text,
    });

    if (result.code === 200) {
      dispatch(hidePopup());
      dispatch(successAlert('Done!'));
      if (reload) {
        reload();
      }
    } else {
      dispatch(errorAlert(result.message ?? 'Not connected to server'));
    }

    dispatch(hideLoading());
  };

  return (
    <div className='login'>
      <div className='inputLogin'>
        <span>USER ID</span>
        <input type='text' defaultValue={data?.user?._id} onChange={(e) => setUser(e.target.value)} />
      </div>
      <div className='inputLogin'>
        <span>Text</span>
        <textarea defaultValue={data?.text} onChange={(e) => setText(e.target.value)} />
      </div>
      <div className='submit' onClick={() => submit()}>
        Submit
      </div>
    </div>
  );
};

export default Add;
